import { logWrapper } from '../../utils';
import { resolveReferences } from '../../utils';

export default {
  flowExecutionService: [
    'runtimeConstant',
    '$http',
    '$q',
    '$filter',
    'webApiSettings',
    'taskModel',
    'executionHistoryModel',
    'elementModel',
    function (
      runtimeConstant,
      $http,
      $q,
      $filter,
      webApiSettings,
      Task,
      ExecutionHistory,
      Element
    ) {
      'use strict';

      function handleError(err, status) {
        switch (status) {
          case 404:
            return {
              status_code: status,
              title: $filter('translate')('ERROR'),
              text: $filter('translate')('TASK NOT FOUND MESSAGE'),
              redirectToList: true,
            };
          case -1:
            return {
              status_code: status,
              title: $filter('translate')('SERVER OFFLINE'),
              text: $filter('translate')('SERVER OFFLINE MESSAGE'),
            };
          case 400:
            var obj = {
              title: $filter('translate')('ERROR'),
              text: $filter('translate')('VERIFY FIELD ERRORS'),
            };
            if (err.modelState) {
              obj.modelState = err.ModelState;
              return obj;
            }
            return obj;
          case 409:
            return {
              title: $filter('translate')('TASK ALREADY COMPLETED'),
              text: $filter('translate')('TASK ALREADY COMPLETED MSG'),
              redirectToList: true,
            };

          case 403:
            return {
              title: $filter('translate')('NO PERMISSION'),
              text: $filter('translate')('NO PERMISSION TASK'),
              redirectToList: true,
            };

          default:
            return {
              title: $filter('translate')('ERROR'),
              text: $filter('translate')('AN ERROR OCCURRED'),
            };
        }
      }

      function listRevisionExecutions(id) {
        var deferred = $q.defer();

        var url = 'workflows/revision/';

        $http
          .get(webApiSettings.apiServiceBaseUri + url + id + '/executions')
          .then(
            function (res) {
              var data = res.data;

              data = resolveReferences(data);

              deferred.resolve(data);
            },
            function (err) {
              var error = handleError(err.data, err.status);
              deferred.reject(error);
            }
          );

        return deferred.promise;
      }

      function loadStep(guid) {
        var deferred = $q.defer();

        var url = 'workflows/step/';

        $http.get(webApiSettings.apiServiceBaseUri + url + guid).then(
          function (res) {
            var data = res.data;
            data = resolveReferences(data);

            var exec = new Task(data);

            deferred.resolve(exec);
          },
          function (err) {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          }
        );

        return deferred.promise;
      }

      function generateReport(guid) {
        var deferred = $q.defer();

        var filter = {
          ReportType: 3,
          StepId: guid,
        };
        $http
          .post(`${webApiSettings.apiServiceBaseUri}reports/generate`, filter, {
            responseType: 'blob',
          })
          .then((res) => {
            deferred.resolve(res);
          })
          .catch((err) => {
            deferred.reject(handleError(err, err.status));
          });

        return deferred.promise;
      }

      function loadWorkflow(guid) {
        var deferred = $q.defer();

        var url = 'workflows/';

        $http.get(webApiSettings.apiServiceBaseUri + url + guid).then(
          function (res) {
            var data = res.data;
            data = resolveReferences(data);

            deferred.resolve(data);
          },
          function (err) {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          }
        );

        return deferred.promise;
      }

      function loadHistories(guid) {
        var deferred = $q.defer();

        var url = 'workflows/step/histories/';

        $http.get(webApiSettings.apiServiceBaseUri + url + guid).then(
          (res) => {
            var data = res.data;
            var result = [];

            data = resolveReferences(data);

            for (var i = 0; i < data.length; i++) {
              result.push(new ExecutionHistory(data[i]));
            }
            deferred.resolve(result);
          },
          function (err) {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          }
        );

        return deferred.promise;
      }

      function loadGps(guid) {
        var deferred = $q.defer();

        var url = 'workflows/gps/';

        $http.get(webApiSettings.apiServiceBaseUri + url + guid).then(
          function (res) {
            var data = res.data;
            var result = [];

            data = resolveReferences(data);

            for (var i = 0; i < data.length; i++) {
              result.push(new Task(data[i]));
            }

            deferred.resolve(result);
          },
          function (err) {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          }
        );

        return deferred.promise;
      }

      function saveHistory(guid, action) {
        var deferred = $q.defer();

        var url = 'workflows/history/';

        $http
          .post(webApiSettings.apiServiceBaseUri + url + guid + '/' + action)
          .then(
            function (res) {
              var data = res.data;
              var result = [];

              data = resolveReferences(data);

              for (var i = 0; i < data.length; i++) {
                result.push(new Task(data[i]));
              }

              deferred.resolve(result);
            },
            function (err) {
              var error = handleError(err.data, err.status);
              deferred.reject(error);
            }
          );

        return deferred.promise;
      }

      function loadNextStep(guid) {
        var deferred = $q.defer();

        var url = 'workflows/step/nextStep/';

        $http.get(webApiSettings.apiServiceBaseUri + url + guid).then(
          function (res) {
            var data = res.data;

            data = resolveReferences(data);

            deferred.resolve(new Element(data));
          },
          function (err) {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          }
        );

        return deferred.promise;
      }

      function getPath(id) {
        var deferred = $q.defer();

        var url = 'workflows/getPath/';

        $http.get(webApiSettings.apiServiceBaseUri + url + id).then(
          function (res) {
            var data = res.data;
            deferred.resolve(data);
          },

          function (err) {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          }
        );

        return deferred.promise;
      }

      function getDownloadLink(id) {
        var deferred = $q.defer();

        var webApiMethod = 'revisions/file/workflow/generate/';

        $http.get(webApiSettings.apiServiceBaseUri + webApiMethod + id).then(
          function (result) {
            var data = result.data;
            var queryChar = data.indexOf('?') > -1 ? '&' : '?';
            var href =
              webApiSettings.apiServiceBaseUri +
              'revisions/file/hash/' +
              data +
              queryChar +
              'download=true';
            deferred.resolve(href);
          },
          function (data) {
            deferred.reject(data);
          }
        );

        return deferred.promise;
      }

      function editRevision(id) {
        var deferred = $q.defer();

        var webApiMethod = 'revisions/checkout/';

        $http
          .get(webApiSettings.apiServiceBaseUri + webApiMethod + id + '/inflow')
          .then(
            function (result) {
              var rev = result.data;
              deferred.resolve(rev);
            },
            function (data) {
              deferred.reject(data);
            }
          );

        return deferred.promise;
      }

      function cancelRevisionEdit(id) {
        var deferred = $q.defer();

        var webApiMethod = 'revisions/cancelcheckout/';

        $http.get(webApiSettings.apiServiceBaseUri + webApiMethod + id).then(
          function () {
            deferred.resolve(true);
          },
          function (data) {
            deferred.reject(data);
          }
        );

        return deferred.promise;
      }

      function nextStep(guid, next) {
        var deferred = $q.defer();

        var url = 'workflows/next/';

        if (
          next.Forms.some(function (f) {
            return Array.isArray(f.value);
          })
        ) {
          var values = next.Forms.filter(function (f) {
            return Array.isArray(f.value);
          });

          for (var i = 0, len = values.length; i < len; i++) {
            values[i].value = values[i].value.join(';');
          }
        }

        $http.post(webApiSettings.apiServiceBaseUri + url + guid, next).then(
          function () {
            deferred.resolve();
          },
          function (err) {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          }
        );

        return deferred.promise;
      }

      function run() {
        try {
          var flowExecutionFactory = {};
          flowExecutionFactory.workflowsEnabled = true;

          flowExecutionFactory.listRevisionExecutions = logWrapper(
            listRevisionExecutions,
            runtimeConstant.isDebugServicesInternals
          );
          flowExecutionFactory.loadHistories = logWrapper(
            loadHistories,
            runtimeConstant.isDebugServicesInternals
          );
          flowExecutionFactory.saveHistory = logWrapper(
            saveHistory,
            runtimeConstant.isDebugServicesInternals
          );
          flowExecutionFactory.loadGps = logWrapper(
            loadGps,
            runtimeConstant.isDebugServicesInternals
          );
          flowExecutionFactory.loadStep = logWrapper(
            loadStep,
            runtimeConstant.isDebugServicesInternals
          );
          flowExecutionFactory.loadWorkflow = logWrapper(
            loadWorkflow,
            runtimeConstant.isDebugServicesInternals
          );
          flowExecutionFactory.loadNextStep = logWrapper(
            loadNextStep,
            runtimeConstant.isDebugServicesInternals
          );
          flowExecutionFactory.nextStep = logWrapper(
            nextStep,
            runtimeConstant.isDebugServicesInternals
          );
          flowExecutionFactory.getDownloadLink = logWrapper(
            getDownloadLink,
            runtimeConstant.isDebugServicesInternals
          );
          flowExecutionFactory.editRevision = logWrapper(
            editRevision,
            runtimeConstant.isDebugServicesInternals
          );
          flowExecutionFactory.cancelRevisionEdit = logWrapper(
            cancelRevisionEdit,
            runtimeConstant.isDebugServicesInternals
          );
          flowExecutionFactory.generateReport = logWrapper(
            generateReport,
            runtimeConstant.isDebugServicesInternals
          );
          flowExecutionFactory.getPath = logWrapper(
            getPath,
            runtimeConstant.isDebugServicesInternals
          );

          return flowExecutionFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
